import { render, staticRenderFns } from "./CholHamoedProgramStudents.vue?vue&type=template&id=521d4e56&"
import script from "./CholHamoedProgramStudents.vue?vue&type=script&lang=js&"
export * from "./CholHamoedProgramStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports